export enum TextOperatorType {
  EQUAL = "EQUAL" as any,
  NOT_EQUAL = "NOT_EQUAL" as any,
  INCLUDES = "INCLUDES" as any,
  NOT_INCLUDES = "NOT_INCLUDES" as any,
}
